import styled from '@emotion/styled';
import { Theme, StyledProps } from './Tabs.types';
import css from '@styled-system/css';

const Tabs = styled.div<StyledProps, Theme>`
  ${(props) =>
    css({
      display: 'flex',
      justifyContent: props.justifyTabs,
      flexWrap: 'wrap',
      borderBottom: '1px solid',
      borderColor: props.hasBorder ? 'neutral' : 'transparent',
    })}

  & > button {
    flex-shrink: 0;
    line-height: 1.2;
    padding-bottom: 6px;
  }

  ${(props) =>
    props.scrollable &&
    css({
      flexWrap: 'nowrap',
      overflowX: 'scroll',
    })}

  ${(props) =>
    props.hideScrollbar &&
    css({
      '-ms-overflow-style': 'hidden',
      scrollbarWidth: 'none',

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    })}
`;

export default Tabs;
